export default __webpack_public_path__ + "static/media/EFCD1433-4FEA-427E-86FC-FC717417B708.beed9e42.jpg";